import api from "../../api";
import * as types from "../mutation-types";
import SETTINGS from "../../settings";

// initial state
const state = {
  is_header_menu_open: false
};

// getters
const getters = {
  headerMenuState: state => state.is_header_menu_open,
};

// actions
const actions = {
  toggleHeaderMenu({
    commit
  }) {
    commit(types.HEADER_MENU_STATE);
  },
  closeHeaderMenu({
    commit
  }) {
    commit(types.HEADER_MENU_STATE, 0);
  },
  openHeaderMenu({
    commit
  }) {
    commit(types.HEADER_MENU_STATE, 1);
  },
};

// mutations
const mutations = {
  [types.HEADER_MENU_STATE](state, val) {
    console.log("mutations HEADER_MENU_STATE",val);
    if (val === undefined) {
      state.is_header_menu_open = !state.is_header_menu_open;
    } else {
      state.is_header_menu_open = val;
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};